import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useOutstandingCreditNoteList = ({ search, page, pageSize }) => {
  const filter = {
    filter: { searchTerm: search },
    paging: { pageIndex: page },
  };

  return useQuery({
    queryKey: ["creditMemoListState", filter],
    // enabled: true,
    queryFn: async () =>
      callApi({
        path: "crMemoList",
        command: "",
        data: JSON.stringify({ list: filter }),
      }),
    placeholderData: keepPreviousData,
    staleTime: 5000,
  });
};
